var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('v-main',[_c('div',{staticClass:"fondo"},[_c('div',{staticClass:"pt-9 mt-8"},[_c('router-view'),_c('login-window')],1)])])],1)
}
var staticRenderFns = []

export { render, staticRenderFns }